export enum InventoryRoutePathNames {
  Inventory = 'inventory',
}
